import React from 'react';
import './OdInformation.scss';

const OdInformation = ({ data }) => {
  const { title, cta, informations: list, ctaLink } = data;

  return (
    <div className="odInformation">
      <div className="odInformation__header">
        <div className="odInformation__title">{title}</div>
        <a className="odInformation__cta od_link" href={ctaLink}>
          {cta}
        </a>
      </div>
      <div className="odInformation__cards">
        {list.slice(0, 4)?.map(information => (
          <div key={information.label} className="odInformation__card">
            <a className="odInformation__cardItem od_link" href={information.link}>
              <img
                alt={information.label}
                className="odInformation__image"
                src={information.imgSrc}
              />
              <div className="odInformation__footer">
                <div className="odInformation__meta">
                  <div>{information.date}</div>
                  <div className="odInformation__border" />
                  <div>{information.tag}</div>
                </div>
                <div className="odInformation__label">{information.label}</div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OdInformation;
